<template>
    <div class="layout-container-box">
      <el-header class="layout-header">
        <Header>
          <template #header-brand>
            <BreadCrumb :breadList="breadList" />
          </template>
        </Header>
      </el-header>
      <el-scrollbar class="layout-main-content" id="content_box">
        <div class="pd-20">
          <div class="list-container">
           
            <div class="pd-32" style="background: #fff">
                
                <ul class="search_box">
                  <li class="search_item">
                    <span class="title">订单编号</span>
                    <el-input style="width: 150px" clearable v-model="queryData.number"></el-input>
                  </li>
                  <li class="search_item">
                    <span class="title">活动名称</span>
                    <el-input style="width: 150px" clearable v-model="queryData.title" placeholder="活动名称模糊搜索"></el-input>
                  </li>
                  <li class="search_item">
                    <span class="title">支付用户</span>
                    <el-input style="width: 150px" clearable v-model="queryData.user" placeholder="支付用户模糊搜索"></el-input>
                  </li>
                  <li class="search_item">
                    <span class="title">支付状态</span>
                    <el-select class="mg-r-12" clearable v-model="queryData.pay_status" >
                      <el-option
                        v-for="option in paymentOptions"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                      ></el-option>
                    </el-select>
                  </li>

                  <li class="search_item">
                    <span class="活动名称">发票状态</span>
                    <el-select class="mg-r-12" clearable v-model="queryData.invoice_status" >
                      <el-option
                        v-for="option in invoiceState"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                      ></el-option>
                    </el-select>
                  </li>
                </ul>
                <el-button type="primary" @click="handleSearch">查询</el-button>
            </div>
              
            <div class="table-con mg-t-12">
              <el-scrollbar>
                <div class="pd-32" style="background: #fff">
                  <el-table :data="ListData" border>
                    <el-table-column
                      prop="number"
                      width="150"
                      show-overflow-tooltip
                      align="center"
                      label="订单编号"
                    />
                    <el-table-column
                      name="title"
                      prop="title"
                      label="活动名称"
                      show-overflow-tooltip
                      width="300"
                    />
                    <el-table-column
                      prop="pay_time"
                      width="150"
                      align="center"
                      label="支付时间"
                      show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                      prop="nick_name"
                      width="100"
                      align="center"
                      label="支付用户"
                    />
                    <el-table-column
                      prop="amount"
                      width="160"
                      show-overflow-tooltip
                      align="center"
                      label="收费金额"
                    />
                    <el-table-column
                      prop="pay_status"
                      width="180"
                      align="center"
                      label="支付状态"
                    >
                    <template #default="scope">
                      {{ scope.row.pay_status==1?'待支付':scope.row.pay_status==2?'支付成功':'支付失败' }}
                    </template>
                    </el-table-column>
                    <el-table-column
                      prop="invoice_status"
                      width="180"
                      align="center"
                      label="发票状态"
                    >
                    <template #default="scope">
                      {{ scope.row.invoice_status==1?'未开票':'已开票' }}
                    </template>
                    </el-table-column>
                    <el-table-column
                      prop="create_time"
                      width="180"
                      align="center"
                      label="开票操作人"
                    />
                    
                    <el-table-column
                      label="操作"
                      width="150"
                      align="center"
                      fixed="right"
                    >
                      <template #default="scope">
                        
                        <el-link
                          class="mg-r-12"
                          type="primary"
                          v-if="scope.row.invoice_status==1"
                          @click="changeStatus(scope.row.id)"
                          >开发票</el-link
                        >
                        <el-link
                          v-if="scope.row.invoice_status === 2"
                          class="mg-r-12"
                          type="primary"
                          @click="
                            checkInfo(scope.row.invoice_info)
                          "
                          >开票信息</el-link
                        >
                        
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="table-pagination-row mg-t-24">
                    <el-pagination
                      v-show="paginationData.total > paginationData.size"
                      :background="background"
                      v-model:current-page.sync="paginationData.current"
                      v-model:page-size.sync="paginationData.size"
                      :layout="layout"
                      :total="paginationData.total"
                      v-bind="$attrs"
                      @current-change="handleCurrentChange"
                      @pagination="getTableData"
                    />
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <el-dialog
        v-model="dialogVisible"
        title="填写开票信息"
        width="30%"
      >
      <el-input
        v-model="invoiceInfo"
        :rows="2"
        type="textarea"
        placeholder="请填写开票信息"
        :before-close="closeDialog"
      />
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="confirmReason">
              确定
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { reactive, onMounted, ref } from "vue";
  import { useRouter } from "vue-router";
  import { ElMessageBox } from "element-plus";
  import SearchFilterBar from "@/components/SearchFilterBar/index.vue";
  import { Ajax, MessageTips } from "@/utils";
  import Header from "@/Layout/components/Header.vue";
  import BreadCrumb from "@/components/BreadCrumb/index.vue";
  
  export default {
    components: {
      Header,
      BreadCrumb,
      SearchFilterBar,
    },
    setup() {
      const router = useRouter();
  
      const state = reactive({
        breadList: [
          {
            name: "订单列表",
          },
        ],
        
        
        queryData: {
          size: 10,
          page: 1,
          user: '',
          number: '',
          title: "",
          pay_status: "",
          invoice_status: "",
        },
        mainTableKey: 1,
      });
      const paymentOptions = ref([
        {value: "1",label: "待支付" },
        {value: "2",label: "支付成功" },
        {value: "3",label: "支付失败" },
      ])
      const invoiceState = ref([
        {value: "1",label: "未开票" },
        {value: "2",label: "已开票" },
      ])
      const invoiceInfo = ref('')
      const invoiceId = ref('')
      const dialogVisible = ref(false)
      const ListData = ref([]);
      const paginationData = ref({
        current: 1,
        size: state.queryData.size,
        total: 0,
      });
      
      // 查询
      const handleSearch = () => {
        getTableData();
      };
  
      const getTableData = async () => {
        const ret = await Ajax.POST({
          url: "/admin/order/list",
          data: state.queryData,
        });
        if (ret.data.code === 200) {
          ListData.value = ret.data.data.items;
          paginationData.value.total = ret.data.data.total;
        } else {
          MessageTips.error(ret.data.msg);
        }
      };
  
      //查看开票信息
      const checkInfo = (data)=>{
        ElMessageBox.alert(data, '开票信息', {
          confirmButtonText: '关闭',
        })
      }
      //开发票
      const changeStatus = async (id) => {
        invoiceId.value = id
        dialogVisible.value=true
        // let str = status == 2 ? "下架" : "发布";
        // ElMessageBox.confirm("确认" + str + "该报告?", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "warning",
        // })
        //   .then(() => {
        //     setStatus(id, status === 2 ? 1 : 2);
        //   })
        //   .catch(() => {
        //     MessageTips.info("已取消" + str);
        //   });
      };
  
      const handleCurrentChange = (val) => {
        state.queryData.page = val;
        paginationData.value.current = val;
        getTableData();
      };
  
      
      const closeDialog = ()=>{
        invoiceInfo.value = ''
        invoiceId.value = ''
        dialogVisible.value=false
      }
      const confirmReason =async ()=>{
        if(invoiceInfo.value == ''){
          MessageTips.info("请填写开票信息");
        }else{
          const ret = await Ajax.POST({
            url: "/admin/order/invoice/" + invoiceId.value,
            data: { invoice_info: invoiceInfo.value },
          });
          if (ret.data.code === 200) {
            getTableData();
            MessageTips.success("开票成功");
            invoiceInfo.value = ''
            invoiceId.value = ''
            dialogVisible.value=false
          } else {
            MessageTips.error(ret.data.msg);
          }
        }
      }
      
  
      onMounted(() => {
        getTableData();
      });
  
      return {
        ...state,
        handleSearch,
        changeStatus,
        handleCurrentChange,
        getTableData,
        ListData,
        paginationData,
        invoiceInfo,
        closeDialog,
        confirmReason,
        dialogVisible,
        checkInfo,
        paymentOptions,
        invoiceState,
      };
    },
    methods: {
      setgender(row, colum) {
        return row.report_type === 1 ? "简报" : "深度";
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .list-container {
    height: 100%;
    .status-text {
      font-size: 14px;
      &.primary {
        color: #409eff;
      }
      &.info {
        color: #909399;
      }
    }
    .table-pagination-row {
      display: flex;
      justify-content: flex-end;
    }
  }
  .search_box{
    display:flex;
    flex-wrap:wrap;
    .search_item{
      display:flex;
      margin-right:10px;
      margin-bottom:10px;
      align-items:center;
      .title{
        text-align:right;
        width:80px;
        margin-right:5px;
      }
    }
  }
  </style>
  